import * as yup from "yup";

// const phoneRegExp =
//   /^0(\+\d{1,3}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const validationSchema = yup.object({
  f_name: yup.string().required("نام اجباری است"),
  l_name: yup.string().required("نام خانوادگی اجباری است"),
  birthdate: yup.string().required("تاریخ تولد اجباری است"),
  education: yup.string().required("تحصیلات اجباری است"),
  job: yup.string(),
  sex: yup.string().required("جنسیت اجباری است"),
  marital_status: yup.string().required("وضعیت تاهل اجباری است"),
  mobile: yup
    .string()
    .length(11, "شماره موبایل باید 11 رقم است")
    .required("شماره موبایل اجباری است"),
  messenger_mobile: yup.string().length(11, "شماره موبایل باید 11 رقم است"),
  // .matches(phoneRegExp, "شماره پیامرسان صحیح نیست"),
  message_receiving: yup.string().required("نحوه دریافت پیام اجباری است"),
  introduction: yup.string().required("نحوه آشنایی اجباری است"),
  do_advertising: yup.string(),
  salavat_num: yup
    .number()
    .min(1, "حداقل مقدار یک صلوات در روز است")
    .max(14000, "حداکثر مقدار صلوات در روز 14000 تا است")
    .required("تعداد صلوات روزانه اجباری است"),
  team_leader: yup.string(),
  state: yup.string().required("استان اجباری است"),
  city: yup.string().required("شهر اجباری است"),
  neighborhood: yup.string().required("محله اجباری است"),
  region_num: yup.string(),
  exact_address: yup.string(),
  hamyari_1: yup.boolean(),
  hamyari_2: yup.boolean(),
  hamyari_3: yup.boolean(),
  hamyari_4: yup.boolean(),
  hamyari_5: yup.boolean(),
  hamyari_6: yup.boolean(),
  hamyari_7: yup.boolean(),
  hamyari_8: yup.boolean(),
  hamyari_9: yup.boolean(),
  hamyari_10: yup.boolean(),
  hamyari_11: yup.boolean(),
  hamyari_12: yup.boolean(),
  hamyari_13: yup.boolean(),
  hamyari_14: yup.boolean(),
  hamyari_15: yup.boolean(),
  hamyari_16: yup.boolean(),
  hamyari_17: yup.boolean(),
  hamyari_18: yup.boolean(),
  hamyari_19: yup.boolean(),
  hamyari_20: yup.boolean(),
  explain: yup.string(),
});
